module.exports = __webpack_public_path__ + "img/UTFREM-17.413df11a.jpg";